// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import actions from '../../../action-list';
import {getDefaultState as getClaimQuestionDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-question';
import {getMccQuestions} from '../../../shared/repositories';

export const readMccQuestions = () =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getMccQuestions();

            const modifiedQuestions = data.map(question => ({...getClaimQuestionDefaultState(), ...question}));

            dispatch({
                data,
                type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_MCC_QUESTIONS
            });

            dispatch({
                questions: modifiedQuestions,
                type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_CLAIM_QUESTIONS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/get-mcc-questions.js